import React from 'react'
import AboutUsHero from '../components/about/AboutUsHero'
import AboutStatsSection from '../components/about/AboutStatsSection'
import WhyWeAreDifferentSection from '../components/about/WhyWeAreDifferentSection'
import OurPromiseSection from '../components/about/OurPromiseSection'
import AboutCtaSection from '../components/about/AboutCtaSection'
import FaqSection from '../components/home/FaqSection'
import SEO from '../components/seo/SEO'

export default function AboutUs() {
  return (
    <>
      <SEO
        title="About Us | Logo Branded Door Mats Johannesburg – Local SA Specialists"
        description="Learn about Logo Branded Door Mats Johannesburg — your trusted local partner for premium custom branded entrance mats. Based in Isando, Kempton Park. 2–3 day delivery across Gauteng and South Africa."
        keywords="about logo branded door mats Johannesburg, custom mat supplier South Africa, branded mat company Gauteng, local mat manufacturer Kempton Park, entrance mat specialist SA"
        url="https://www.logobrandeddoormats.co.za/about"
        image="https://www.logobrandeddoormats.co.za/images/sectionimages/abouthero.png"
      />
      <AboutUsHero />
      <AboutStatsSection />
      <WhyWeAreDifferentSection />
      <OurPromiseSection />
      <AboutCtaSection />
      <FaqSection />
    </>
  )
}
